<template>
  <div>
    <v-card elevation="1">
      <div class="flex w-full rounded-tl-sm rounded-tr-sm">
        <v-card-title style="color: var(--darkBlue)">
          <v-row class="mb-1">
            <v-col
              class="text-lg-left text-center pb-0 pb-sm-2"
              cols="12"
              sm="12"
              md="9"
              lg="9"
              xl="9"
            >
              <h3>{{ $t('navigationDrawerMenu.bulkInvoiceAdd') }}</h3>
            </v-col>
            <v-col
              class="d-flex align-center justify-end pb-0 pb-sm-2"
              cols="12"
              sm="12"
              md="3"
              lg="3"
              xl="3"
            >
              <RefreshButton :refreshFunction="refreshData"></RefreshButton>
            </v-col>
          </v-row>
        </v-card-title>
      </div>

      <v-divider />

      <v-card-text fill-height fluid>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(submitBulkInvoice)">
            <v-row align="center" class="mb-4">
              <v-col cols="12" md="3" lg="3" xl="3">
                <FormElement
                  v-model="form.invoiceFile"
                  :validationLabel="$t('labels.invoiceFile')"
                  :rules="'required'"
                  :formType="{
                    name: 'file',
                    data: {
                      accept:
                        'application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xlsx,.xls',
                    },
                  }"
                  :topLabel="true"
                  :labelShown="false"
                  :placeholder="$t('labels.invoiceFile')"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4" xl="4">
                <FormElement
                  v-model="form.integrationLogistic"
                  :validationLabel="$t('labels.integrationLogistic')"
                  :rules="'required'"
                  :formType="{
                    name: 'select',
                    items: {
                      data: integrationLogisticOptions,
                      value: 'value',
                      text: 'text',
                    },
                  }"
                  :topLabel="true"
                  :labelShown="false"
                  :placeholder="$t('labels.integrationLogistic')"
                />
              </v-col>
              <v-col
                v-if="form.integrationLogistic === 1"
                cols="12"
                md="4"
                lg="4"
                xl="4"
              >
                <FormElement
                  v-model="form.fedexInvoiceType"
                  :validationLabel="$t('labels.fedexInvoiceType')"
                  :rules="'required'"
                  :formType="{
                    name: 'select',
                    items: {
                      data: fedexInvoiceTypeOptions,
                      value: 'value',
                      text: 'text',
                    },
                  }"
                  :topLabel="true"
                  :labelShown="false"
                  :placeholder="$t('labels.fedexInvoiceType')"
                />
              </v-col>
              <v-col
                cols="12"
                md="1"
                lg="1"
                xl="1"
                class="d-flex align-end"
                style="
                  padding-top: 0 !important;
                  padding-bottom: 36px !important;
                "
              >
                <v-btn
                  type="submit"
                  color="primary"
                  class="button"
                  rounded
                  style="width: 100%; height: 56px"
                >
                  {{ $t('buttons.add') }}
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </form>
        </ValidationObserver>

        <v-divider v-if="tableData.length > 0" class="my-4" />

        <v-row v-if="tableData.length > 0" class="mb-4">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              @click="submitSelectedInvoices"
              color="primary"
              class="button"
              rounded
              style="
                color: white;
                text-transform: unset !important;
                background-color: #0077d5;
                padding: 12px 24px;
                border-radius: 30px !important;
                font-weight: bolder;
                font-size: medium;
              "
              elevation="0"
            >
              {{ $t('buttons.save') }}
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          v-if="pageLength > 0"
          :headers="tableHeaders"
          :items="tableData"
          :loading="$store.state.loadingStatus"
          hide-default-footer
          :no-data-text="$t('messages.noData')"
          :item-key="'ShipmentId'"
        >
          <template v-slot:[`item.ExportDate`]="{ item }">
            {{ item.ExportDate ? convertToLocal(item.ExportDate) : '-' }}
          </template>
          <template v-slot:[`item.Weight`]="{ item }">
            {{ item.Weight || '-' }}
          </template>
          <template v-slot:[`item.InvoiceAmount`]="{ item }">
            {{ item.InvoiceAmount || '-' }}
          </template>
          <template v-slot:[`item.Amount`]="{ item }">
            {{ item.Amount || '-' }}
          </template>
          <template v-slot:no-data>
            <div class="my-10 d-flex flex-column align-center">
              <h4>{{ $t('messages.noData') }}</h4>
            </div>
          </template>
          <template v-slot:footer>
            <div class="d-flex justify-center mt-8" v-if="pageLength > 1">
              <v-row align="center" justify="center">
                <v-col
                  v-if="
                    $vuetify.breakpoint.md ||
                    $vuetify.breakpoint.lg ||
                    $vuetify.breakpoint.xl
                  "
                  md="2"
                ></v-col>
                <v-col cols="9" sm="12" md="7" lg="7" xl="7">
                  <v-pagination
                    class="mr-2"
                    @input="onPageChange"
                    :value="page"
                    :length="pageLength"
                    :total-visible="10"
                    circle
                  ></v-pagination>
                </v-col>
                <v-col
                  cols="11"
                  sm="11"
                  md="3"
                  lg="3"
                  xl="3"
                  class="ml-md-auto d-flex align-center mb-6 mb-md-0 pr-3 pr-md-6"
                >
                  <v-select
                    :value="pageSize"
                    :items="[{ name: '10', value: 10 }]"
                    :label="$t('labels.selectItemsPerPage')"
                    item-value="value"
                    item-text="name"
                    outlined
                    dense
                    disabled
                    rounded
                  >
                  </v-select>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import RefreshButton from '../components/RefreshButton.vue';
import FormElement from '../components/FormElement.vue';
import ShipmentService from '../services/ShipmentService';

export default {
  name: 'BulkInvoiceAdd',
  components: {
    RefreshButton,
    FormElement,
  },
  data() {
    return {
      form: {
        invoiceFile: null,
        integrationLogistic: null,
        fedexInvoiceType: null,
      },
      integrationLogisticOptions: [
        { value: 1, text: 'Fedex' },
        { value: 2, text: 'UPS' },
      ],
      fedexInvoiceTypeOptions: [],
      page: 1,
      pageSize: 10,
      tableData: [],
      totalItems: 0,
      activeIntegrationLogistic: null,
    };
  },
  computed: {
    pageLength() {
      if (this.pageSize == null || this.totalItems == null) {
        return 0;
      }
      return Math.ceil(this.totalItems / this.pageSize);
    },
    tableHeaders() {
      if (!this.activeIntegrationLogistic) {
        return [];
      }

      const headers = [];

      // Fedex columns (IntegrationLogistic = 1)
      if (this.activeIntegrationLogistic === 1) {
        headers.push(
          {
            text: this.$t('labels.waybill'),
            value: 'Waybill',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.svcPkgLabel'),
            value: 'SvcPkgLabel',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.fedexInvoiceDescription'),
            value: 'FedexInvoiceDescription',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.chargeableWeight'),
            value: 'Weight',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.invoiceAmount'),
            value: 'InvoiceAmount',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.invoiceCurrency'),
            value: 'InvoiceCurrency',
            sortable: false,
            align: 'center',
          }
        );
      }

      // UPS columns (IntegrationLogistic = 2)
      if (this.activeIntegrationLogistic === 2) {
        headers.push(
          {
            text: this.$t('labels.exportDate'),
            value: 'ExportDate',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.waybill'),
            value: 'Waybill',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.description'),
            value: 'Description',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.chargeableWeight'),
            value: 'Weight',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.invoiceAmount'),
            value: 'InvoiceAmount',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.invoiceCurrency'),
            value: 'InvoiceCurrency',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.amount2'),
            value: 'Amount',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.amountCurrency'),
            value: 'AmountCurrency',
            sortable: false,
            align: 'center',
          }
        );
      }

      return headers;
    },
  },
  mounted() {
    this.setup();
    this.initializeFedexInvoiceTypeOptions();
  },
  methods: {
    setup() {
      // Initialize component
      this.resetForm();
    },
    initializeFedexInvoiceTypeOptions() {
      this.fedexInvoiceTypeOptions = [
        { value: 0, text: this.$t('labels.vergiFaturalari') },
        { value: 1, text: this.$t('labels.navlunFaturalari') },
      ];
    },
    resetForm() {
      this.form = {
        invoiceFile: null,
        integrationLogistic: null,
        fedexInvoiceType: null,
      };
      this.activeIntegrationLogistic = null;
      this.tableData = [];
      this.totalItems = 0;
      this.page = 1;
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },
    refreshData() {
      this.setup();
    },
    onPageChange(newPage) {
      this.page = newPage;
      this.loadInvoiceData();
    },
    async loadInvoiceData() {
      if (!this.form.invoiceFile || !this.activeIntegrationLogistic) {
        return;
      }
      // Only require fedexInvoiceType if integrationLogistic is Fedex (value 1)
      if (
        this.activeIntegrationLogistic === 1 &&
        (this.form.fedexInvoiceType === null ||
          this.form.fedexInvoiceType === undefined)
      ) {
        return;
      }

      try {
        this.$store.state.loadingStatus = true;

        // Create FormData for file upload
        const formData = new FormData();
        formData.append('InvoiceFile', this.form.invoiceFile);
        formData.append('IntegrationLogistic', this.activeIntegrationLogistic);
        formData.append('FedexInvoiceType', this.form.fedexInvoiceType);
        formData.append('Page', this.page);
        formData.append('PageSize', this.pageSize);

        const response = await ShipmentService.insertInvoiceExcel(formData);

        if (response.data) {
          if (response.data.Result) {
            this.tableData = response.data.Result;
          }
          if (
            response.data.TotalItems !== null &&
            response.data.TotalItems !== undefined
          ) {
            this.totalItems = response.data.TotalItems;
          }
        }
      } catch (error) {
        window.showError(
          error.response?.data?.Message ||
            error.message ||
            this.$t('messages.errorOccurred')
        );
      } finally {
        this.$store.state.loadingStatus = false;
      }
    },
    async submitSelectedInvoices() {
      if (!this.form.invoiceFile) {
        window.showError(
          this.$t('messages.requiredField', {
            value: this.$t('labels.invoiceFile'),
          })
        );
        return;
      }

      if (!this.form.integrationLogistic) {
        window.showError(
          this.$t('messages.requiredField', {
            value: this.$t('labels.integrationLogistic'),
          })
        );
        return;
      }

      // Only require fedexInvoiceType if integrationLogistic is Fedex (value 1)
      if (
        this.form.integrationLogistic === 1 &&
        (this.form.fedexInvoiceType === null ||
          this.form.fedexInvoiceType === undefined)
      ) {
        window.showError(
          this.$t('messages.requiredField', {
            value: this.$t('labels.fedexInvoiceType'),
          })
        );
        return;
      }

      try {
        this.$store.state.loadingStatus = true;

        // Create FormData with the form fields
        const formData = new FormData();
        formData.append('InvoiceFile', this.form.invoiceFile);
        formData.append('IntegrationLogistic', this.form.integrationLogistic);
        // Only add FedexInvoiceType if Fedex is selected (IntegrationLogistic === 1)
        if (this.form.integrationLogistic === 1) {
          // Handle FedexInvoiceType: 0 is a valid value, so check for null/undefined explicitly
          const fedexInvoiceType =
            this.form.fedexInvoiceType !== null &&
            this.form.fedexInvoiceType !== undefined
              ? this.form.fedexInvoiceType
              : '';
          formData.append('FedexInvoiceType', fedexInvoiceType);
        }

        const response = await ShipmentService.bulkInsertInvoice(formData);

        window.showSuccess(
          this.$t('messages.successfulAdd', {
            value: this.$t('navigationDrawerMenu.bulkInvoiceAdd'),
          })
        );

        // Reset form after successful submission
        this.resetForm();
      } catch (error) {
        window.showError(
          error.response?.data?.Message ||
            error.message ||
            this.$t('messages.errorOccurred')
        );
      } finally {
        this.$store.state.loadingStatus = false;
      }
    },
    async submitBulkInvoice() {
      if (!this.form.invoiceFile) {
        window.showError(
          this.$t('messages.requiredField', {
            value: this.$t('labels.invoiceFile'),
          })
        );
        return;
      }

      if (!this.form.integrationLogistic) {
        window.showError(
          this.$t('messages.requiredField', {
            value: this.$t('labels.integrationLogistic'),
          })
        );
        return;
      }

      // Only require fedexInvoiceType if integrationLogistic is Fedex (value 1)
      if (
        this.form.integrationLogistic === 1 &&
        (this.form.fedexInvoiceType === null ||
          this.form.fedexInvoiceType === undefined)
      ) {
        window.showError(
          this.$t('messages.requiredField', {
            value: this.$t('labels.fedexInvoiceType'),
          })
        );
        return;
      }

      this.activeIntegrationLogistic = this.form.integrationLogistic;

      try {
        this.$store.state.loadingStatus = true;

        // Create FormData for file upload
        const formData = new FormData();
        formData.append('InvoiceFile', this.form.invoiceFile);
        formData.append('IntegrationLogistic', this.activeIntegrationLogistic);
        formData.append('FedexInvoiceType', this.form.fedexInvoiceType);
        formData.append('Page', this.page);
        formData.append('PageSize', this.pageSize);

        const response = await ShipmentService.insertInvoiceExcel(formData);

        if (response.data) {
          if (response.data.Result) {
            this.tableData = response.data.Result;
          }
          if (
            response.data.TotalItems !== null &&
            response.data.TotalItems !== undefined
          ) {
            this.totalItems = response.data.TotalItems;
          }
        }

        window.showSuccess(
          this.$t('messages.successfulAdd', {
            value: this.$t('navigationDrawerMenu.bulkInvoiceAdd'),
          })
        );
        // Don't reset form to keep the table visible
      } catch (error) {
        window.showError(
          error.response?.data?.Message ||
            error.message ||
            this.$t('messages.errorOccurred')
        );
      } finally {
        this.$store.state.loadingStatus = false;
      }
    },
  },
};
</script>
